/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type ListAIEvaluationRunsPathParams = NonNullable<operations['listAIEvaluationRuns']['parameters']['path']>;

export type ListAIEvaluationRunsQueryParams = NonNullable<operations['listAIEvaluationRuns']['parameters']['query']>;

export interface Input extends ListAIEvaluationRunsPathParams {
  apiVersion?: string;
  query?: ListAIEvaluationRunsQueryParams;
  header: NonNullable<operations['listAIEvaluationRuns']['parameters']['header']>;
}

export async function listAIEvaluationRuns(
  { apiVersion, query, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projectKey}/ai/evaluations/{evaluationId}/runs', {
    params: { path, query, header },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
